import { CartAddEvent } from '@theme/events'

document.addEventListener('DOMContentLoaded', () => {
  /* =================================================
     GLOBAL STATE
  ================================================= */
  window.purchaseType = window.purchaseType || 'onetime'
  window.selectedVariantId = null
  window.selectedSellingPlanId = null
  window.selectedFrequency = null
  window.isSellingPlanLoading = false

  const sellingPlanCache = {}
  const productCache = {}

  /* =================================================
     DOM HELPERS
  ================================================= */
  const cartridgeButtons = () => document.querySelectorAll('.cartridge-btn')
  const refillButtons = () => document.querySelectorAll('.refill-btn')
  const refillGroup = () => document.querySelector('.refill-group')
  const customATC = () => document.getElementById('custom-atc')
  const subscriptionPriceEl = document.getElementById('subscription-price')
  const onetimePriceEl = document.getElementById('onetime-price')

  /* =================================================
     MONEY FORMAT (EU SAFE)
  ================================================= */
  function formatMoney(cents) {
    const value = cents / 100
    return `€${value.toFixed(2).replace('.', ',')}`
  }

  /* =================================================
     FETCH PRODUCT (CACHE)
  ================================================= */
  async function getProduct(handle) {
    if (productCache[handle]) return productCache[handle]
    const res = await fetch(`/products/${handle}.js`)
    const product = await res.json()
    productCache[handle] = product
    return product
  }

  /* =================================================
     LOAD SELLING PLANS
  ================================================= */
  async function loadSellingPlans(handle) {
    if (sellingPlanCache[handle]) return sellingPlanCache[handle]

    const product = await getProduct(handle)

    const plans = product.selling_plan_groups
      .flatMap(g => g.selling_plans)
      .map(p => ({
        id: p.id,
        name: p.name.toLowerCase()
      }))

    const variants = {}
    product.variants.forEach(v => {
      variants[v.id] =
        v.selling_plan_allocations?.map(a => a.selling_plan_id) || []
    })

    sellingPlanCache[handle] = { plans, variants }
    return sellingPlanCache[handle]
  }

  /* =================================================
     RESOLVE PLAN BY FREQUENCY
  ================================================= */
  function resolveSellingPlan(handle, variantId, frequency) {
    const data = sellingPlanCache[handle]
    if (!data || !frequency) return null

    const plan = data.plans.find(p => p.name.includes(frequency))
    if (!plan) return null

    return data.variants[variantId]?.includes(plan.id)
      ? plan.id
      : null
  }

  /* =================================================
     UPDATE SUBSCRIPTION PRICE
  ================================================= */
  // async function updateSubscriptionPrice() {
  //   if (!subscriptionPriceEl) return
  //   if (!window.selectedSellingPlanId) return

  //   const active = document.querySelector('.cartridge-btn.active')
  //   if (!active) return

  //   const product = await getProduct(active.dataset.handle)
  //   const variant = product.variants.find(v =>
  //     v.id === Number(active.dataset.variantId)
  //   )

  //   const allocation =
  //     variant?.selling_plan_allocations?.find(
  //       a => a.selling_plan_id === Number(window.selectedSellingPlanId)
  //     )

  //   subscriptionPriceEl.textContent = allocation
  //     ? formatMoney(allocation.price)
  //     : formatMoney(variant.price)
  // }

  async function updatePrice() {
    if (!subscriptionPriceEl) return

    const active = document.querySelector('.cartridge-btn.active')
    if (!active) return

    const product = await getProduct(active.dataset.handle)
    const variant = product.variants.find(
      v => v.id === Number(active.dataset.variantId)
    )

    console.log(variant.price);

    if (!variant) return

    // 🟢 ONE-TIME
    if (window.purchaseType === 'onetime') {
      onetimePriceEl.textContent = formatMoney(variant.price)
      // subscriptionPriceEl.textContent = formatMoney(variant.price)
      return
    }

    // 🔵 SUBSCRIPTION
    if (window.selectedSellingPlanId) {
      const allocation = variant.selling_plan_allocations?.find(
        a => a.selling_plan_id === Number(window.selectedSellingPlanId)
      )

      subscriptionPriceEl.textContent = allocation
        ? formatMoney(allocation.price)
        : formatMoney(variant.price)
    }
  }


  /* =================================================
     AUTO SELECTS
  ================================================= */
  function autoSelectFirstCartridge() {
    const list = cartridgeButtons()
    if (!list.length) return

    list.forEach(b => b.classList.remove('active'))
    list[0].classList.add('active')

    window.selectedVariantId = Number(list[0].dataset.variantId)
  }

  function autoSelectFirstRefill() {
    const list = refillButtons()
    if (!list.length) return

    list.forEach(b => b.classList.remove('active'))
    list[0].classList.add('active')
    window.selectedFrequency = list[0].dataset.frequency
  }

  /* =================================================
     PURCHASE TYPE TOGGLE
  ================================================= */
  function updateUI() {
    // Cartridge ALWAYS visible
    // Refill ONLY for subscription
    if (refillGroup()) {
      refillGroup().style.display =
        window.purchaseType === 'subscription' ? 'block' : 'none'
    }

    // Subscription init
    if (window.purchaseType === 'subscription') {
      autoSelectFirstRefill()

      const active = document.querySelector('.cartridge-btn.active')
      if (active) {
        window.isSellingPlanLoading = true
        loadSellingPlans(active.dataset.handle).then(() => {
          window.selectedSellingPlanId = resolveSellingPlan(
            active.dataset.handle,
            window.selectedVariantId,
            window.selectedFrequency
          )
          window.isSellingPlanLoading = false
          updatePrice()
        })
      }
    } else {
      window.selectedSellingPlanId = null
      window.selectedFrequency = null
      updatePrice();
    }
  }

  /* =================================================
     INITIAL LOAD
  ================================================= */
  autoSelectFirstCartridge()
  updateUI()
  

  document.addEventListener('purchaseTypeChanged', e => {
    window.purchaseType = e.detail
    updateUI()
  })

  /* =================================================
     CLICK HANDLERS
  ================================================= */
  document.addEventListener('click', async e => {
    /* ---- CARTRIDGE ---- */
    const cartridge = e.target.closest('.cartridge-btn')
    if (cartridge) {
      cartridgeButtons().forEach(b => b.classList.remove('active'))
      cartridge.classList.add('active')

      window.selectedVariantId = Number(cartridge.dataset.variantId)

      if (window.purchaseType === 'subscription') {
        window.isSellingPlanLoading = true
        await loadSellingPlans(cartridge.dataset.handle)

        window.selectedSellingPlanId = resolveSellingPlan(
          cartridge.dataset.handle,
          window.selectedVariantId,
          window.selectedFrequency
        )

        window.isSellingPlanLoading = false
        updatePrice()
      } else {
        updatePrice()
      }
      return
    }

    /* ---- FREQUENCY ---- */
    const refill = e.target.closest('.refill-btn')
    if (refill) {
      refillButtons().forEach(b => b.classList.remove('active'))
      refill.classList.add('active')

      window.selectedFrequency = refill.dataset.frequency

      const active = document.querySelector('.cartridge-btn.active')
      if (active) {
        window.selectedSellingPlanId = resolveSellingPlan(
          active.dataset.handle,
          window.selectedVariantId,
          window.selectedFrequency
        )
        updatePrice()
      }
    }
  })

  /* =================================================
     CUSTOM ADD TO CART
  ================================================= */
  
 

  // document.addEventListener('click', async e => {
  //   const btn = e.target.closest('#custom-atc')
  //   if (!btn) return

  //   if (!window.selectedVariantId) {
  //     alert('Please select a cartridge')
  //     return
  //   }

  //   if (
  //     window.purchaseType === 'subscription' &&
  //     !window.selectedSellingPlanId
  //   ) {
  //     alert('Please select frequency')
  //     return
  //   }

  //   btn.disabled = true
  //   btn.classList.add('loading')

  //   try {
  //     /* --------------------------------
  //       1️⃣ Build FormData EXACTLY like theme
  //     -------------------------------- */
  //     const formData = new FormData()
  //     formData.append('id', window.selectedVariantId)
  //     formData.append('quantity', 1)

  //     if (window.purchaseType === 'subscription') {
  //       formData.append('selling_plan', window.selectedSellingPlanId)
  //     }

  //     // 🔑 Collect cart section IDs (CRITICAL)
  //     const sectionIds = []
  //     document.querySelectorAll('cart-items-component').forEach(el => {
  //       if (el.dataset.sectionId) {
  //         sectionIds.push(el.dataset.sectionId)
  //       }
  //     })

  //     formData.append('sections', sectionIds.join(','))

  //     /* --------------------------------
  //       2️⃣ Add to cart using theme route
  //     -------------------------------- */
  //     const res = await fetch(Theme.routes.cart_add_url, {
  //       method: 'POST',
  //       headers: { Accept: 'application/json' },
  //       body: formData
  //     })

  //     const data = await res.json()

  //     if (data.status) {
  //       throw new Error(data.message || 'Add to cart failed')
  //     }

  //     /* --------------------------------
  //       3️⃣ DISPATCH CartAddEvent (THIS FIXES DRAWER)
  //     -------------------------------- */
  //     document.dispatchEvent(
  //       new CartAddEvent(
  //         {},
  //         window.selectedVariantId.toString(),
  //         {
  //           source: 'custom-atc',
  //           itemCount: 1,
  //           productId: Theme.product?.id,
  //           sections: data.sections
  //         }
  //       )
  //     )

  //   } catch (err) {
  //     console.error(err)
  //     alert('Something went wrong')
  //   } finally {
  //     btn.disabled = false
  //     btn.classList.remove('loading')
  //   }
  // })

  document.addEventListener('click', async e => {
    const btn = e.target.closest('#custom-atc');
    if (!btn) return;

    const mainProductVariantId = btn.dataset.mainProductId;

    // -------------------------------
    // VALIDATION
    // -------------------------------
    if (!window.selectedVariantId) {
      alert('Please select a cartridge');
      return;
    }

    if (
      window.purchaseType === 'subscription' &&
      !window.selectedSellingPlanId
    ) {
      alert('Please select frequency');
      return;
    }

    btn.disabled = true;
    btn.classList.add('loading');

    try {
      /* --------------------------------
        Collect cart drawer sections
      -------------------------------- */
      const sectionIds = [];
      document.querySelectorAll('cart-items-component').forEach(el => {
        if (el.dataset.sectionId) {
          sectionIds.push(el.dataset.sectionId);
        }
      });

      /* --------------------------------
        1️⃣ ADD MAIN PRODUCT
      -------------------------------- */
      if (mainProductVariantId) {
        const mainFormData = new FormData();
        mainFormData.append('id', mainProductVariantId);
        mainFormData.append('quantity', 1);
        mainFormData.append('sections', sectionIds.join(','));

        const mainRes = await fetch(Theme.routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: mainFormData
        });

        const mainData = await mainRes.json();
        if (mainData.status) {
          throw new Error(mainData.message || 'Main product add failed');
        }
      }

      /* --------------------------------
        2️⃣ ADD SELECTED PRODUCT
          (ONETIME OR SUBSCRIPTION)
      -------------------------------- */
      const secondFormData = new FormData();
      secondFormData.append('id', window.selectedVariantId);
      secondFormData.append('quantity', 1);
      secondFormData.append('sections', sectionIds.join(','));

      // only attach selling plan for subscription
      if (window.purchaseType === 'subscription') {
        secondFormData.append(
          'selling_plan',
          window.selectedSellingPlanId
        );
      }

      const secondRes = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: secondFormData
      });

      const secondData = await secondRes.json();
      if (secondData.status) {
        throw new Error(secondData.message || 'Product add failed');
      }

      /* --------------------------------
        3️⃣ DISPATCH CartAddEvent
      -------------------------------- */
      document.dispatchEvent(
        new CartAddEvent(
          {},
          window.selectedVariantId.toString(),
          {
            source: 'custom-atc',
            itemCount: 2,
            productId: Theme.product?.id,
            sections: secondData.sections
          }
        )
      );

    } catch (err) {
      console.error(err);
      alert('Something went wrong while adding to cart');
    } finally {
      btn.disabled = false;
      btn.classList.remove('loading');
    }
  });







})
